module.exports = __webpack_public_path__ + "static/media/featured_img.b60ab1eb.png";